import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Menu.css';
import PeopleIcon from '@mui/icons-material/People';
import PercentIcon from '@mui/icons-material/Percent';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import TrackChangesSharpIcon from '@mui/icons-material/TrackChangesSharp';
import BusinessCenterSharpIcon from '@mui/icons-material/BusinessCenterSharp';
import AutoAwesomeMotionSharpIcon from '@mui/icons-material/AutoAwesomeMotionSharp';
import ShoppingCartSharpIcon from '@mui/icons-material/ShoppingCartSharp';
import InsertDriveFileSharpIcon from '@mui/icons-material/InsertDriveFileSharp';
import AssessmentSharpIcon from '@mui/icons-material/AssessmentSharp';

//Functie de extragere la url-ului
const getPathFromUrl = (url) => {
  const { pathname } = new URL(url, window.location.origin);
  return pathname;
};

const Menu = ({ isOpen, setIsOpen }) => {
  const [permissions, setPermissions] = useState([]);
  const [openMenus, setOpenMenus] = useState({});
  const navigate = useNavigate();

  //verificarea permisiunilor
  useEffect(() => {
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions) {
      const parsedPermissions = JSON.parse(storedPermissions);
      if (parsedPermissions && parsedPermissions.pages) {
        setPermissions(parsedPermissions.pages);
      }
    }
  }, []);

  //functie de logout
  const handleLogout = () => {
    localStorage.removeItem('permissions');
    console.clear();
    navigate('/');
  };

  //functie de gestionare a submeniurilor ( inchis/deschis)
  const toggleSubmenu = (menuName) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };

  //inchide meniul pe ferestre mici
  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };

  //grupari in meniu
  const groupedMenu = [
    {
      section: 'General Business',
      icon: <PeopleIcon className="icon section-icon" />,
      items: [
        { name: 'Home', url: '/home', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: 'Suppliers', url: '/supplier', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: 'Exchange Rate', url: '/exchange-rate', icon: <TrackChangesSharpIcon className="icon" /> },
      ],
    },
    {
      section: 'Sales',
      icon: <PercentIcon className="icon section-icon" />,
      items: [
        {
          name: '[S1] Opportunities',
          icon: <TrackChangesSharpIcon className="icon" />,
          children: [
            { name: 'Register', url: '/opportunities', icon: <PercentIcon className="icon" /> },
            { name: 'Clients', url: '/clients', icon: <PeopleIcon className="icon" /> },
          ],
        },
        {
          name: '[S2] CRM',
          icon: <TrackChangesSharpIcon className="icon" />,
          children: [
            { name: 'Client Portfolio', url: '/client-portfolio', icon: <PercentIcon className="icon" /> },
          ],
        },
      ],
    },
    {
      section: 'Bidding',
      icon: <BusinessCenterSharpIcon className="icon section-icon" />,
      items: [
        { name: '[C1] Project codes', url: '/project_codes', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[C2] Offer registry', url: '/offer_registry', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[C3] Client contracts', url: '/client_contracts', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[C4] Invoices registry', url: '/invoices_register', icon: <TrackChangesSharpIcon className="icon" /> },
      ],
    },
    {
      section: 'Projects',
      icon: <AutoAwesomeMotionSharpIcon className="icon section-icon" />,
      items: [
        { name: '[P1] Project budget', url: '/project-budget', icon: <TrackChangesSharpIcon className="icon" /> },
        {
          name: '[P2] Cost control',
          icon: <TrackChangesSharpIcon className="icon" />,
          children: [
            { name: 'Suppliers Contracts', url: '/supplier-contracts' },
            { name: 'Orders and additional pappers', url: '/orders-additional-pappers' },
            { name: 'External resource invoice', url: '/external-resource-invoice' },
            { name: 'Price/Hour', url: '/price-per-hour' },
            { name: 'Internal resource cost', url: '/internal-resource-cost' },
            { name: 'Monthly percent', url: '/monthly-percent' },
          ],
        },
      ],
    },
    {
      section: 'Procurement',
      icon: <ShoppingCartSharpIcon className="icon section-icon" />,
      items: [
        {
          name: '[O1] Products',
          icon: <TrackChangesSharpIcon className="icon" />,
          children: [
            { name: 'Category', url: '/category' },
            { name: 'Type of Materials', url: '/type-materials' },
            { name: 'Dimensions', url: '/dimensions' },
            { name: 'Products', url: '/product' },
          ],
        },
        { name: '[O2] Contracts', url: '/contract-register', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[O3] Purchase Order', url: '/purchase-order', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[O4] Reception', url: '/reception', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[O5] Invoice', url: '/invoice-procurement', icon: <TrackChangesSharpIcon className="icon" /> },
      ],
    },
    {
      section: 'HR',
      icon: <InsertDriveFileSharpIcon className="icon section-icon" />,
      items: [
        { name: '[H1] Employees', url: '/employees', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[H2] Document Registry', url: '/hr-document-registry', icon: <TrackChangesSharpIcon className="icon" /> },
      ],
    },
    {
      section: 'Administrative',
      icon: <InsertDriveFileSharpIcon className="icon section-icon" />,
      items: [
        { name: '[A1] Costs & Administrative', url: '/cost-control-administrative', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[A2] Document registry', url: '/document-registry', icon: <TrackChangesSharpIcon className="icon" /> },
        { name: '[A4] Fleet Management', url: '/all-autovehicles', icon: <TrackChangesSharpIcon className="icon" /> },
      ],
    },
    {
        section: 'Reports',
        icon: <AssessmentSharpIcon className="icon section-icon" />,
        items: [
          {
            name: 'Administrative Reports',
            icon: <TrackChangesSharpIcon className="icon" />,
            children: [
              { name: 'Expenses Report', url: '/expensesreport' },
              { name: 'Expenses Report Actual Cost', url: '/expensesreportactualcost'},
            ],
          },
        { 
          name: 'Bidding Reports',
            icon: <TrackChangesSharpIcon className="icon" />,
            children: [
              { name: 'Project Report', url: '/projectreport'},
              { name: 'Active Project Codes', url: '/active-project-codes-report'},
            ],      
        },
        { 
          name: 'PM Reports',
            icon: <TrackChangesSharpIcon className="icon" />,
            children: [
              {  name: 'Project Expenses', url: '/projectexpenses'},
              {  name: 'Project Expense Per Costs Elements', url: '/projectexpensespercostselements'},
              {  name: 'External Resource Report', url: '/externalresourcereport'},
              {  name: 'Unfinished Production Report', url: '/unfinishedproduction'},
            ],      
        },
        { 
          name: 'Procurement Reports',
            icon: <TrackChangesSharpIcon className="icon" />,
            children: [
              {  name: 'Product Report', url: '/productreports'},
              {  name: 'Purchase Order Report', url: '/purchaseorderreports'},
              {  name: 'Invoice Procurement Report', url: '/invoiceprocurementreports'},
            ],      
        },
        { 
          name: 'Sales Reports',
            icon: <TrackChangesSharpIcon className="icon" />,
            children: [
              {  name: 'Opportunities Report', url: '/opportunitiesreport'},
            ],      
        },
      ],
    }
  ];

  //verifica daca utilizatorul are acces la cel putin o pagina din sectiune pt a decide daca afiseaza sectiunea sau nu
  const hasAccessToSection = (section) => {
    return section.items.some(item => {
      if (item.children) {
        return item.children.some(child =>
          permissions.some(permission => getPathFromUrl(permission.url) === child.url && permission.can_view)
        );
      } else {
        return permissions.some(permission => getPathFromUrl(permission.url) === item.url && permission.can_view);
      }
    });
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <ul className="meniu">
        {groupedMenu
          .filter(section => hasAccessToSection(section))
          .map((group) => (
            <div key={group.section}>
              <div className="section-title">
                {group.icon}
                <span>{group.section}</span>
              </div>

              {group.items.map((item, index) => {
                if (item.children) {
                  const visibleChildren = item.children.filter((child) =>
                    permissions.some(
                      (permission) => getPathFromUrl(permission.url) === child.url && permission.can_view
                    )
                  );
                  if (visibleChildren.length === 0) return null;

                  return (
                    <li key={index} className="menu-item">
                      <div className="menu-link" onClick={() => toggleSubmenu(item.name)}>
                        {item.icon}
                        <span>{item.name}</span>
                        {openMenus[item.name] ? (
                          <ExpandLessIcon className="submenu-arrow" />
                        ) : (
                          <ExpandMoreIcon className="submenu-arrow" />
                        )}
                      </div>
                      {openMenus[item.name] && (
                        <ul className="submenu">
                          {visibleChildren.map((child, subIndex) => (
                            <li key={subIndex} className="submenu-item">
                              <NavLink
                                to={child.url}
                                onClick={handleLinkClick}
                                className={({ isActive }) =>
                                  isActive ? 'menu-link active' : 'menu-link'
                                }
                              >
                                <span>{child.name}</span>
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                }

                const hasPermission = permissions.some(
                  (permission) => getPathFromUrl(permission.url) === item.url && permission.can_view
                );

                return hasPermission ? (
                  <li key={index} className="menu-item">
                    <NavLink
                      to={item.url}
                      onClick={handleLinkClick}
                      className={({ isActive }) => (isActive ? 'menu-link active' : 'menu-link')}
                    >
                      {item.icon}
                      <span>{item.name}</span>
                    </NavLink>
                  </li>
                ) : null;
              })}
            </div>
          ))}
      </ul>

      <button className="settings-button" onClick={handleLogout}>
        <LogoutIcon className="icon" />
        Logout
      </button>
    </div>
  );
};

export default Menu;
